export default "__VITE_ASSET__24f22f62__"